import api from '../api'
import {updateRecentActivities} from './recentActivities'
import store from '../store'
import debounce from 'lodash/debounce'
import moment from 'moment'
import * as Sentry from '@sentry/browser'

//const MINIMUM_TIME_BETWEEN_REFRESHES=1000*45 //30seconds

const MINIMUM_TIME_BETWEEN_REFRESHES=1000*5 //30seconds



export function fetchSingleQuestionPoll(pollId) {
  	return (dispatch) => api.fetch(`/polls/${pollId}?correctPercent=true`)
	    .then((response) => {
		      dispatch({ type: 'FETCH_SINGLE_QUESTION_POLL_SUCCESS', response })
		      return response
	    })
	    .catch((error) => {
			return error
		})
}


export function fetchQuestionPollforPusher(pollId,dispatch) {
  	return api.fetch(`/polls/${pollId}`)
	    .then((response) => {
		    store.dispatch({ type: 'FETCH_SINGLE_QUESTION_POLL_SUCCESS', response })
		      return response
	    })
	    .catch((error) => {
	   
		})
}



const debouncedFetchSingleQuestionPoll=debounce(fetchQuestionPollforPusher,1500)


export function refetchQuestionPolls() {
	return (dispatch) => api.batchedFetch('/polls?canceled=false&sort=modified&correctPercent=true&parentArchived=false')
	    .then((response) => {
		       dispatch({ type: 'FETCH_QUESTION_POLLS_SUCCESS', response })
	    })
		.catch((error) => {
			return error
		})

}


function fetchQueueQuestionPolls(questionPollsLastRefreshedTime){
	let queryString='/polls?hasResponses=false&canceled=false&sort=modified&parentArchived=false'
	if(questionPollsLastRefreshedTime){
		queryString+=`&modifiedAfter=${questionPollsLastRefreshedTime}`
	}

	return (dispatch) => api.batchedFetch(queryString)
	    .then((response) => {
	    	if(questionPollsLastRefreshedTime){
		 	  dispatch({ type: 'REFRESH_QUESTION_POLLS_SUCCESS', response})
			}else{
				 
				dispatch({ type: 'FETCH_QUEUE_QUESTION_POLLS_SUCCESS', response})
			}
	    })
	    .catch((error) => {
			return error
	})
}


function fetchHistoryQuestionPolls(questionPollsLastRefreshedTime){
	let queryString='/polls?hasResponses=true&canceled=false&sort=modified&correctPercent=true&parentArchived=false'
	if(questionPollsLastRefreshedTime){
		queryString+=`&modifiedAfter=${questionPollsLastRefreshedTime}`
	}
	return (dispatch) => api.batchedFetch(queryString)
	    .then((response) => {
		      if(questionPollsLastRefreshedTime){
		 	  dispatch({ type: 'REFRESH_QUESTION_POLLS_SUCCESS', response})
			}else{
				 
				dispatch({ type: 'FETCH_HISTORY_QUESTION_POLLS_SUCCESS', response})
			}
	    })
	    .catch((error) => {
			return error
	})
}





export function fetchQuestionPolls() {
	const state = store.getState()
	if(state.questionPollsRefreshedTimestamp){
		const nowDate =moment()
		const timeSinceLastRefresh=nowDate - moment(state.questionPollsRefreshedTimestamp)
		if(timeSinceLastRefresh > MINIMUM_TIME_BETWEEN_REFRESHES){
			
			store.dispatch({ type: 'REFRESH_QUESTION_POLLS_REQUEST'})
			return (dispatch) => {
				dispatch(fetchQueueQuestionPolls(state.questionPollsRefreshedTimestamp))
				dispatch(fetchHistoryQuestionPolls(state.questionPollsRefreshedTimestamp))

			}
	    }
	    else{
		 return({ type: 'WAIT_TO_REFRESH'})

		}
	}

  	else {
  		store.dispatch({ type: 'FETCH_QUESTION_POLLS_REQUEST'})
  		return (dispatch) => {
			dispatch(fetchQueueQuestionPolls())
			dispatch(fetchHistoryQuestionPolls())

		}
	}

}




function fetchQueueSetPolls(setPollsLastRefreshedTime){
	let queryString='/setpolls?hasResponses=false&canceled=false&sort=modified&parentArchived=false'
	if(setPollsLastRefreshedTime){
		queryString+=`&modifiedAfter=${setPollsLastRefreshedTime}`
	}

	return (dispatch) => api.batchedFetch(queryString)
	    .then((response) => {
	    	if(setPollsLastRefreshedTime){
		 	  dispatch({ type: 'REFRESH_SET_POLLS_SUCCESS', response})
			}else{
				 
				dispatch({ type: 'FETCH_QUEUE_SET_POLLS_SUCCESS', response})
			}
	    })
	    .catch((error) => {
			return error
	})
}


function fetchHistorySetPolls(setPollsLastRefreshedTime){
	let queryString='/setpolls?hasResponses=true&canceled=false&sort=modified&correctPercent=true&parentArchived=false'
	if(setPollsLastRefreshedTime){
		queryString+=`&modifiedAfter=${setPollsLastRefreshedTime}`
	}
	return (dispatch) => api.batchedFetch(queryString)
	    .then((response) => {
		      if(setPollsLastRefreshedTime){
		 	  dispatch({ type: 'REFRESH_SET_POLLS_SUCCESS', response})
			}else{
				 
				dispatch({ type: 'FETCH_HISTORY_SET_POLLS_SUCCESS', response})
			}
	    })
	    .catch((error) => {
			return error
	})
}


export function fetchSetPolls() {
	const state = store.getState()
	if(state.setPollsRefreshedTimestamp){
		const nowDate =moment()
		const timeSinceLastRefresh=nowDate - moment(state.setPollsRefreshedTimestamp)
		if(timeSinceLastRefresh > MINIMUM_TIME_BETWEEN_REFRESHES){
			
			store.dispatch({ type: 'REFRESH_SET_POLLS_REQUEST'})
			return (dispatch) => {
				dispatch(fetchQueueSetPolls(state.setPollsRefreshedTimestamp))
				dispatch(fetchHistorySetPolls(state.setPollsRefreshedTimestamp))

			}
	    }
	    else{
		 return({ type: 'WAIT_TO_REFRESH'})

		}
	}

  	else {
  		store.dispatch({ type: 'FETCH_SET_POLLS_REQUEST'})
  		return (dispatch) => {
			dispatch(fetchQueueSetPolls())
			dispatch(fetchHistorySetPolls())

		}
	}

}






export function fetchSingleSetPoll(pollId) {
  	return (dispatch) => api.fetch(`/setpolls/${pollId}?correctPercent=true`)
	    .then((response) => {
		      dispatch({ type: 'FETCH_SINGLE_SET_POLL_SUCCESS', response })
		      return response
	    })
	    .catch((error) => {
			return error
		})
}



export function fetchSetPollforPusher(pollId,dispatch) {
  	return api.fetch(`/setpolls/${pollId}?correctPercent=true`)
	    .then((response) => {
		    store.dispatch({ type: 'FETCH_SINGLE_SET_POLL_SUCCESS', response })
		      return response
	    })
	    .catch((error) => {
		})
}



const debouncedFetchSingleSetPoll=debounce(fetchSetPollforPusher,1000,{leading: true})



export function refetchSetPolls() {
	return (dispatch) => api.batchedFetch('/setpolls?canceled=false&sort=modified&correctPercent=true&parentArchived=false')
	    .then((response) => {
		       dispatch({ type: 'FETCH_SET_POLLS_SUCCESS', response })
	    })
		.catch((error) => {
			return error
		})

}



export function fetchPollsForSet(setId) {

  	return (dispatch) => api.fetch(`/setpolls?setObject=${setId}&hasResponses=false&limit=100&canceled=false&sort=modified&parentArchived=false`)
	    .then((response) => {
		       dispatch({ type: 'FETCH_POLLS_FOR_A_SET_SUCCESS', response })
	    })
		.catch((error) => {
			return error
		})

}

export function fetchPollsForQuestion(questionId) {

  	return (dispatch) => api.fetch(`/polls?question=${questionId}&hasResponses=false&limit=100&canceled=false&sort=modified&parentArchived=false`)
	    .then((response) => {
		       dispatch({ type: 'FETCH_POLLS_FOR_A_QUESTION_SUCCESS', response })
	    })
		.catch((error) => {
			return error
		})

}








// //debounce to prevent issues when creating multiple polls for an item in quick sucession
// var debouncedUpdateRecentActivities=_.debounce(updateRecentActivities,500,{'leading': false })


export function newQuestionPoll(data,isBatchRequest) {	
  	return (dispatch) => {
		if(!isBatchRequest){
			dispatch({ type: 'CREATE_QUESTION_POLL_REQUEST', data })	
		}
		return api.post('/polls/',data)
	    	.then((response) => {
		      dispatch({ type: 'CREATE_QUESTION_POLL_SUCCESS', response,syncAction:true })
		  	//dispatch(debouncedUpdateRecentActivities(response.question,'question','queue'))			      
		      dispatch(updateRecentActivities(response.question,'question','queue'))
		 	 return response
		    })
	     .catch(err => {
	    	  dispatch({ type: 'CREATE_QUESTION_POLL_FAILURE', data })
		      Sentry.withScope(scope => {
					scope.setExtra('request', data)
					Sentry.captureException(new Error(err))
				})
	  })

	}
}

export function newSetPoll(data,isBatchRequest) {	
  	return (dispatch) => {
  		if(!isBatchRequest){
			dispatch({ type: 'CREATE_SET_POLL_REQUEST', data })	
		}
		return api.post('/setpolls/',data)
	    	.then((response) => {
		      dispatch({ type: 'CREATE_SET_POLL_SUCCESS', response,syncAction:true })
		      
		      dispatch(updateRecentActivities(response.setObject,'set','queue'))
		      return response
		    })
	     .catch(err => {
	      dispatch({ type: 'CREATE_SET_POLL_FAILURE', data })
	       Sentry.withScope(scope => {
					scope.setExtra('request', data)
					Sentry.captureException(new Error(err))
				})
		})
	}
}


//delete

export function deleteQuestionPoll(pollId) {
  	return (dispatch) => api.delete(`/polls/${pollId}`)
	    .then((response) => {
		      dispatch({ type: 'DELETE_QUESTION_POLL_SUCCESS', pollId,syncAction:true})
		      return response
	    })
	    .catch((error) => {
			return error
		})
}


export function deleteSetPoll(pollId) {
  	return (dispatch) => api.delete(`/setpolls/${pollId}`)
	    .then((response) => {
		      dispatch({ type: 'DELETE_SET_POLL_SUCCESS', pollId,syncAction:true})
		      return response
	    })
	   	.catch(err => {
	     	
		})
}




//update 

export function updateQuestionPoll(pollId,data) {	
  	return (dispatch) => {
		dispatch({ type: 'UPDATE_QUESTION_POLL_REQUEST', pollId,data,syncAction:true  })	
		return api.put(`/polls/${pollId}`,data)
	    	.then((response) => {
		      dispatch({ type: 'UPDATE_QUESTION_POLL_SUCCESS', response,pollId,syncAction:true })

		 	 return response
		    })
	     .catch(err => {
	     dispatch(refetchQuestionPolls())
	     return 'failed'
	})
	}
}

export function updateSetPoll(pollId,data) {
  	return (dispatch) => {
  		dispatch({ type: 'UPDATE_SET_POLL_REQUEST', pollId,data,syncAction:true  })	
  		return api.put(`/setpolls/${pollId}`,data)
	    .then((response) => {
		      dispatch({ type: 'UPDATE_SET_POLL_SUCCESS', response,pollId,syncAction:true })
		      return response

	    })
	     .catch(err => {
	     	dispatch(refetchSetPolls())
	     	 return 'failed'
		})
	}
}


export function pusherPollReceived(data) {

	return (dispatch) => {
		if(data.setPollId){
			//const pollObject=data.setPollPoll
			dispatch({ type: 'PUSHER_POLL_RECEIVED',data})	
			debouncedFetchSingleSetPoll(data.setPollId,dispatch)
		}
		else if(data.poll){
			const pollObject=data.poll

			dispatch({ type: 'PUSHER_POLL_RECEIVED',data})	
			const response=pollObject
			dispatch({ type: 'FETCH_SINGLE_QUESTION_POLL_SUCCESS', response })
			//debouncedFetchSingleQuestionPoll(pollObject.id,dispatch)	
		}

	}
}




export function getQuestionPollForControl(pollId) {
	return (dispatch) => {
		debouncedFetchSingleQuestionPoll(pollId,dispatch)
	
		return({ type: 'DEBOUNCED FETCH'})	

				
	}
}

export function fetchSetPollForControl(pollId) {
	return (dispatch) => {
		debouncedFetchSingleSetPoll(pollId,dispatch)
		return({ type: 'DEBOUNCED FETCH'})	
	}
}






// WEBPACK FOOTER //
// ./src/actions/polls.js